module.exports = __webpack_public_path__ + "img/pharma.9f16edd7.svg";